/**
 * Analytics
 */
import { HIGHARC_DOMAIN } from "./env";

export const POSTHOG_API_KEY = "phc_VItzEFP1bIM5VDZXqVRfsdYWLh81rHPWURBXOgp5ib6";
export const POSTHOG_PROJECT_ID = 114947;

/**
 * Contact and marketing information
 */

export const SITE_DESCRIPTION = "Design, estimate, sell and build, online and in 3D - all in one place.";

export const INTERCOM_APP_ID = "nv9gbps2";
export const INTERCOM_LINK_ID = "intercom-messenger-target";
export const INTERCOM_HELP_CENTER_ID = 4177870;

export const SUPPORT_EMAIL_ADDRESS = `support@${HIGHARC_DOMAIN}`;
export const PRESS_EMAIL_ADDRESS = `press@${HIGHARC_DOMAIN}`;
export const CONTACT_EMAIL_ADDRESS = `hello@${HIGHARC_DOMAIN}`;
export const DEFAULT_EMAIL_SENDER = `"Higharc" <${CONTACT_EMAIL_ADDRESS}>`;

export const SUPPORT_EMAILS = {
  CREDITS: {
    mailto: `mailto:${SUPPORT_EMAIL_ADDRESS}`,
    list: [SUPPORT_EMAIL_ADDRESS] as string[],
  },
  CONTACT: {
    mailto: `mailto:${CONTACT_EMAIL_ADDRESS}`,
    list: [CONTACT_EMAIL_ADDRESS] as string[],
  },
  PRESS: {
    mailto: `mailto:${PRESS_EMAIL_ADDRESS}`,
    list: [PRESS_EMAIL_ADDRESS] as string[],
  },
} as const;

export const SOCIAL_URLS = {
  facebook: "https://www.facebook.com/higharchomes",
  instagram: "https://www.instagram.com/higharchomes",
  linkedin: "https://www.linkedin.com/company/higharc",
  twitter: "https://twitter.com/HigharcHomes",
} as const;
